import {Activity} from './interfaces';

export const calculateCustomerFromHostname = (hostname: string) => {
    let CUSTOMER_DOMAIN = '';
    if (!hostname) {
        console.warn('No hostname provided.');
        return CUSTOMER_DOMAIN;
    }

    const token = hostname.split('.');
    switch (token[0]) {
        case 'localhost':
            CUSTOMER_DOMAIN = 'extravega.com';
            // this.CUSTOMER_DOMAIN = 'wonder-sys.com';
            break;
        case 'wondersys':
            CUSTOMER_DOMAIN = 'wonder-sys.com';
            break;
        case 'extravega':
            CUSTOMER_DOMAIN = 'extravega.com';
            break;
        case 'tis':
            CUSTOMER_DOMAIN = 'theitalianspace.com';
            break;
        case 'extraglass':
            CUSTOMER_DOMAIN = 'extraglass.it';
            break;
        default:
            CUSTOMER_DOMAIN = '';
    }

    // Special cases
    if (hostname === 'evtest.wonder-sys.com' || hostname === 'tistest.wonder-sys.com') {
        CUSTOMER_DOMAIN = 'theitalianspace.com';
    } else if (hostname === 'app.extravega.com') {
        CUSTOMER_DOMAIN = 'extravega.com';
    } else if (hostname === 'extravega.wonder-sys.com') {
        CUSTOMER_DOMAIN = 'wonder-sys.com';
    } else if (hostname.includes('extraglass')) {
        CUSTOMER_DOMAIN = 'extraglass.it';
    } else if (hostname.includes('localhost')) {
        CUSTOMER_DOMAIN = 'extravega.com';
    }

    console.log('CUSTOMER_DOMAIN: ', CUSTOMER_DOMAIN);
    return CUSTOMER_DOMAIN;

}

const PREFERRED_CATEGORY_ORDER = [
    'Amministrazione',
    'Ufficio tecnico',
    'Progettazione Interna',
    'Lavorazioni Interne'
];

export const sortActivities = (a: Activity, b: Activity, cMap: Map<string, string>) => {
    const catA = a.category?.trim() || '';
    const catAValue = (cMap.get(catA) || '').trim();
    const catB = b.category?.trim() || '';
    const catBValue = (cMap.get(catB) || '').trim();

    const hasCatA = !!(catA && catAValue);
    const hasCatB = !!(catB && catBValue);

    // If one does not have a category, move it to the bottom
    if (!hasCatA && hasCatB) {
        return 1;
    }
    if (hasCatA && !hasCatB) {
        return -1;
    }

    if (hasCatA && hasCatB) {
        const indexA = PREFERRED_CATEGORY_ORDER.indexOf(catAValue);
        const indexB = PREFERRED_CATEGORY_ORDER.indexOf(catBValue);

        if (indexA !== -1 && indexB !== -1) {
            if (indexA !== indexB) {
                return indexA - indexB;
            }
        } else if (indexA !== -1) {
            return -1;
        } else if (indexB !== -1) {
            return 1;
        } else {
            const catComp = catAValue.localeCompare(catBValue);
            if (catComp !== 0) {
                return catComp;
            }
        }
    }

    const actA = a.activity || '';
    const actB = b.activity || '';
    return actA.localeCompare(actB);
};
